<section class="hero">
  <div>
    <p class="eyebrow">Intelligence</p>
    <h1>Hotspots</h1>
  </div>

  <div class="group-toggle">
    <button type="button" [class.active]="groupBy() === 'file'" (click)="switchGroupBy('file')">Files</button>
    <button type="button" [class.active]="groupBy() === 'folder'" (click)="switchGroupBy('folder')">Folders</button>
  </div>
</section>

@if (fileHotspots(); as hotspots) {
  <section class="layout-grid">
    <article class="panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">{{ groupBy() === 'file' ? 'File' : 'Folder' }} Hotspots</p>
          <h2>Highest issue concentration</h2>
        </div>
      </div>

      @if (hotspots.items.length) {
        <div class="hotspot-list">
          @for (item of hotspots.items; track item.path; let idx = $index) {
            <div class="hotspot-row">
              <div class="hotspot-rank">{{ idx + 1 }}</div>
              <div class="hotspot-body">
                <div class="hotspot-path" [title]="item.path">{{ item.path }}</div>
                <div class="hotspot-bar-track">
                  <div class="hotspot-bar-fill" [style.width]="barWidth(item.issueCount, maxIssueCount(hotspots))"></div>
                </div>
                <div class="hotspot-meta">
                  <span class="badge badge-issues">{{ item.issueCount }} issues</span>
                  <span class="badge badge-prs">{{ item.pullRequestCount }} PRs</span>
                  @if (item.recurringIssueCount > 0) {
                    <span class="badge badge-recurring">{{ item.recurringIssueCount }} recurring</span>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="panel-empty">
          <strong>No hotspots detected</strong>
          <span>No paths with elevated issue concentration in the selected range.</span>
        </div>
      }
    </article>

    @if (repositoryHotspots(); as repoHotspots) {
      <article class="panel">
        <div class="panel-head">
          <div>
            <p class="panel-kicker">Repository Hotspots</p>
            <h2>Most problematic repositories</h2>
          </div>
        </div>

        @if (repoHotspots.items.length) {
          <div class="table-shell">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Repository</th>
                  <th>Issues</th>
                  <th>Paths</th>
                </tr>
              </thead>
              <tbody>
                @for (repo of repoHotspots.items; track repo.repositoryId) {
                  <tr>
                    <td class="rank-cell">{{ repo.rank }}</td>
                    <td><strong>{{ repo.repositoryName }}</strong></td>
                    <td>{{ repo.totalIssues }}</td>
                    <td>{{ repo.distinctProblemPaths }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="panel-empty">
            <strong>No data</strong>
            <span>No repository hotspot data for this range.</span>
          </div>
        }
      </article>
    }
  </section>
} @else if (loading()) {
  <section class="state-card">Loading hotspots…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="state-button" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No hotspot data returned for the selected range.</p>
  </section>
}
